import { render, staticRenderFns } from "./LawClientModal.vue?vue&type=template&id=7c1bcede&"
import script from "./LawClientModal.vue?vue&type=script&lang=js&"
export * from "./LawClientModal.vue?vue&type=script&lang=js&"
import style0 from "./LawClientModal.vue?vue&type=style&index=0&id=7c1bcede&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports